'use strict';

const ImageSlider = (($) => {

    const NAME = 'imageSlider';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {}

    class ImageSlider {

        // totalWidth = 0;

        static get Default() {
            return Default
        }

        constructor($element, config) {
            this._config = $.extend({}, Default, config);
            this.$element = $element;
            this.container = $element.find('ul');

            this.fadeDuration = 2000;
            this.intervalId;

            this.position = 0;
            this.isSliding = false;

            this.init();
            this.addEventListeners();

            var _ = this;
        }

        init() {
            // console.log('image slider');

            this.setHeight();
            this.container.find('li').eq(0).addClass('active');

            this.startAutoRun();
        }

        addEventListeners() {
            var _self = this;

            this.$element.on('click', function (e) {
                _self.handleClick()
            });

            $(window).on('resize', function() {
                _self.resetHeight();
            })
        }

        handleClick(e) {
            // console.log('mouse click');
            this.showNext();
            this.restartAutoRun();
        }

        setHeight() {
            var ulHeight = this.container.height();

            this.container.attr('style', 'height: ' + ulHeight + 'px');
            this.container.addClass('initialized');

            // console.log(ulHeight);
        }

        resetHeight() {
            var ulHeight = this.container.find('li.active').find('img').height();

            this.container.attr('style', 'height: ' + ulHeight + 'px');
            // this.container.addClass('initialized');

            // console.log(ulHeight);
        }

        startAutoRun() {
            this.intervalId = setInterval($.proxy(this.showNext, this), 10000);
        }

        restartAutoRun() {
            clearInterval(this.intervalId);
            this.startAutoRun();
        }

        showNext() {
            var _self = this;

            if (this.isSliding) {
                return;
            }
            this.isSliding = true;

            var activeSlide = this.container.find('li.active');
            var nextSlide = activeSlide.next();
            // console.log(nextSlide);

            if (nextSlide.length === 0) {
                nextSlide = this.container.find('li').eq(0);
            }

            activeSlide.fadeOut(_self.fadeDuration, 'swing');
            nextSlide.fadeIn(
                _self.fadeDuration,
                'swing',
                function() {
                    _self.isSliding = false;
                    _self.container.find('li').removeClass('active');
                    nextSlide.addClass('active');
                }
            )
        }

        static _jQueryInterface(config) {
            config = config || {};
            return this.each(() => {
                let $this = $(this);
                let _config = $.extend(
                    {},
                    ImageSlider.Default,
                    $this.data(),
                    typeof config === 'object' && config
                );

                new ImageSlider(this, _config)
            })
        }
    }

    $.fn[NAME] = ImageSlider._jQueryInterface;
    $.fn[NAME].Constructor = ImageSlider;
    $.fn[NAME].noConflict = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return ImageSlider._jQueryInterface
    };

    return ImageSlider;

})(jQuery);

export default ImageSlider;